module.exports = __webpack_public_path__ + "static/media/NoBedTruckIcon.11257213.svg";